<template>
  <div class="flex gap-4 mr-6 text-sm">
    <div class="flex items-center gap-2">
      <span
        v-if="referralEligible"
        class="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-1 rounded-full"
      >
        <CheckCircle class="w-4 h-" />
        Eligible for referral
      </span>
      <span v-else class="flex items-center gap-2 text-red-500 bg-red-100 px-4 py-1 rounded-full">
        <XCircle class="w-4 h-4" />
        Not eligible for referral yet
      </span>
    </div>
    <button
      @click="$emit('update:activeTab', 'application')"
      class="px-4 py-2 border-[1px] border-gray-200 rounded-md hover:bg-white transition-all duration-200"
      :class="tabClasses('application')"
    >
      Job Application
    </button>
    <button
      @click="$emit('update:activeTab', 'referral')"
      class="px-4 py-2 border-[1px] border-gray-200 rounded-md hover:bg-white transition-all duration-200"
      :class="tabClasses('referral')"
    >
      Referral Package
    </button>
    <button
      @click="$emit('update:activeTab', 'email_preview')"
      class="px-4 py-2 border-[1px] border-gray-200 rounded-md hover:bg-white transition-all duration-200"
      :class="tabClasses('email_preview')"
    >
      Email Preview
    </button>
  </div>
</template>

<script setup lang="ts">
import { CheckCircle, XCircle } from 'lucide-vue-next'
interface Props {
  activeTab: string
  referralEligible: boolean
}

const props = defineProps<Props>()

defineEmits<{
  'update:activeTab': [value: string]
}>()

const tabClasses = (tabName: string) => ({
  'text-blue-600 font-medium': props.activeTab === tabName,
  'text-gray-500 hover:text-gray-700': props.activeTab !== tabName
})
</script>
